module.exports = __webpack_public_path__ + "static/img/tdsmall1.d0df7b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/tdsmall1.jpg
// module id = CYna
// module chunks = 0